import { useRouter } from 'next/router'

export function isCurrentRoute(href) {
  if (!href) return
  const router = useRouter()

  let processedRoute = router.route

  for (let key in router?.query) {
    const val = router?.query[key] as string
    processedRoute = processedRoute.replace(`[${key}]`, val)
  }

  const routeWithoutLang = processedRoute
  const routeWithLang = `/${router.locale}${processedRoute}`

  return (
    href.toString() === routeWithLang || href.toString() === routeWithoutLang
  )
}
